var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-list-cell',{staticClass:"language",attrs:{"format":_vm.format,"type":"stat"}},[_c('div',{staticClass:"language-band",class:{[_vm.bandClass]: true}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }